import { render, staticRenderFns } from "./LineBroadcastTag.vue?vue&type=template&id=622f137c&scoped=true&"
import script from "./LineBroadcastTag.vue?vue&type=script&lang=js&"
export * from "./LineBroadcastTag.vue?vue&type=script&lang=js&"
import style0 from "./LineBroadcastTag.vue?vue&type=style&index=0&id=622f137c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622f137c",
  null
  
)

export default component.exports